import { combineReducers } from "redux";
import auth from "./auth";
import data from './data.reducers';
import ui from './ui.reducer';

export default combineReducers({
  auth,
  data,
  ui
});